import { create } from "zustand"
import type { TAddCompositeCategoryModalStore, TVariants, TVariant } from "types/configuration.type"

// Add composite category store
export const useCompositeCategoryStore = create<TAddCompositeCategoryModalStore>((set) => ({
	category: {
		name: "",
		label: "",
		topLevelCategory: "",
		superCategory: "",
		modelNumbers: [],
		variants: {},
	},

	setFormValues: ({ name, label, topLevelCategory, superCategory }) =>
		set((state) => ({
			category: { ...state.category, name, label, topLevelCategory, superCategory },
		})),

	setModelNumbers: (modelNumbers: number[]) =>
		set((state) => ({
			category: { ...state.category, modelNumbers },
		})),

	setVariants: (variants: TVariants) =>
		set((state) => ({
			category: {
				...state.category,
				variants,
			},
		})),

	updateVariant: (combinationId: string, variant: TVariant) =>
		set((state) => ({
			category: {
				...state.category,
				variants: {
					...state.category.variants,
					[combinationId]: variant,
				},
			},
		})),

	deleteVariant: (combinationId: string) =>
		set((state) => {
			const newVariants = { ...state.category.variants }
			delete newVariants[combinationId]

			return {
				category: {
					...state.category,
					variants: newVariants,
				},
			}
		}),

	resetForm: () =>
		set(() => ({
			category: {
				name: "",
				label: "",
				topLevelCategory: "",
				superCategory: "",
				modelNumbers: [],
				variants: {},
			},
		})),
}))
